<template>
  <div class="box content">
    <h1 class="title">Shreddify</h1>
    <h2 class="subtitle has-text-weight-normal">Get shredded</h2>

    <blockquote>
      Shreddify aims to provide you with tools that will help you get shredded.
      Resources you'll find here will help you with both your training and
      nutrition.
    </blockquote>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.box {
  max-width: 600px;
  margin: 0 auto;
}
</style>
